import parse, { DOMNode, domToReact } from 'html-react-parser';

export const TermsParser: React.FC<{ text: string }> = (props) => {
  const textWithBr = props.text?.replace(/\n/g, '<br />') ?? '';

  const options = {
    replace: (domNode: DOMNode) => {
      if (domNode.type === 'tag') {
        if (domNode.name === 'h1') {
          return <h1 className="font-bold text-lg">{domToReact(domNode.children as DOMNode[])}</h1>;
        }
        if (domNode.name === 'br') {
          return <br />;
        }

        return undefined;
      }
    },
  };
  const parsedContent = parse(textWithBr, options);

  return <div aria-live="polite">{parsedContent}</div>;
};
